/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-manager.reducer';

export const HospitalManagerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalManagerEntity = useAppSelector(state => state.hospitalManager.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalManagerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalManager.detail.title">HospitalManager</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.name">Name</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.email">Email</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.email}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.dateOfBirth}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.cursor}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.education">Education</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.education}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.experience}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.gender}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.hospitalManager.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{hospitalManagerEntity.bloodGroup}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalManager.tmUser">Tm User</Translate>
          </dt>
          <dd>{hospitalManagerEntity.tmUser ? hospitalManagerEntity.tmUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalManager.contactCode">Contact Code</Translate>
          </dt>
          <dd>{hospitalManagerEntity.contactCode ? hospitalManagerEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalManager.hospital">Hospital</Translate>
          </dt>
          <dd>{hospitalManagerEntity.hospital ? hospitalManagerEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hospital-manager" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hospital-manager/${hospitalManagerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalManagerDetail;
